import React from 'react';
import {
  translate as t,
  Restricted,
} from 'admin-on-rest';
import { RaisedButton } from 'material-ui';
import JsPDF from 'jspdf';
import html2canvas from 'html2canvas';

import './styles.css';

class Diploma extends React.Component { // eslint-disable-line

  createPdf = () => {
    html2canvas(document.querySelector('.diploma-card')).then((canvas) => {
      const pdf = new JsPDF('l', 'mm', 'a4');
      pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 0, 0, 297, 210);
      pdf.save('pdf.pdf');
    });
  }

  render() {
    const { location: { state = { title: 'kursnamn', name: 'micke' } }, translate } = this.props;
    return (
      <div className="diploma-container">
        <div className="diploma-card">
          <img alt="pinchoversity logo" className="diploma-pinchoversity-logo" src="/pinchoversityx600.png" />
          <h1>Diplom</h1>
          <span>utdelas till</span>
          <h1>{state.name}</h1>
          <p>för att ha avklarat</p>
          <h2>{state.title}</h2>

          <div className="diploma-footer">
            <div className="diploma-meta-fields">
              <span className="diploma-signature">Underskrift:<div className="diploma-signature-underline"></div></span>
              <span className="diploma-date">Datum:<div className="diploma-date-underline"></div></span>
            </div>
          </div>

        </div>
        <RaisedButton className="diploma-download-button" onClick={this.createPdf} children={translate('diploma.download')} />
      </div>
    );
  }
}

const Dipdip = (props) => (
  <Restricted authParams={{ route: '/profile/:id/diploma' }} location={props.location}>
    {props.user ? <Diploma {...props} /> : <div />}
  </Restricted>
);

export default t(Dipdip);
